import React from 'react';
import clsx from 'clsx';

export const PlusOutlinedIcon = ({
  width,
  height,
  fill,
  className,
  ...rest
}) => {
  return (
    <svg
      viewBox='64 64 896 896'
      focusable='false'
      width={width}
      height={height}
      className={clsx('icon icon-plus-outlined', className)}
      {...rest}
    >
      <path
        fill={fill}
        d='M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z'
      />
      <path
        fill={fill}
        d='M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z'
      />
    </svg>
  );
};

PlusOutlinedIcon.defaultProps = {
  width: 16,
  height: 16,
  fill: 'currentColor'
};
